<script setup>
import {useBaseStore} from "~/stores/base";
import {useProductStore} from "~/stores/product";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits([])

/** props **/
const props = defineProps({
  swiperSlideIndex: {
    default: 0
  }
})

/** data **/

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const voteInfo = computed(() => useProductStore().getterProductConfig.voteInfo)

/** watch **/

/** methods **/

/** lifecycle **/

</script>

<template>
  <div class="slide-vote-introduce-mobile" v-if="isMobile">
    <div class="desc">{{ voteInfo.guideDesc }}</div>
    <video
      v-if="swiperSlideIndex === 1"
      :src="voteInfo.guideVideoUrl"
      :poster="voteInfo.guideImageUrl"
      muted
      autoplay
      playsinline
      loop
      type="video/mp4"
    />
  </div>
  <div class="slide-vote-introduce-desktop" v-else>
    <div class="desc">{{ voteInfo.guideDesc }}</div>
    <video
      v-if="swiperSlideIndex === 1"
      :src="voteInfo.guideVideoUrl"
      :poster="voteInfo.guideImageUrl"
      muted
      autoplay
      playsinline
      loop
      type="video/mp4"
    />
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.slide-vote-introduce-mobile {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .desc {
    padding: 0 16px;

    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.056px;
  }

  video {
    margin-top: 16px;
    width: 100%;
    height: 372px;
  }
}

.slide-vote-introduce-desktop {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  .desc {
    padding: 0 16px;

    font-family: "TWK Lausanne";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 18px; /* 128.571% */
    letter-spacing: -0.056px;
  }

  video {
    margin-top: 16px;
    width: 100%;
    height: 472px;
  }
}
</style>
